<template>
  <portal to="after-create-order-modal">
    <Modal
      :value="value"
      @input="v => $emit('input', v)"
      class="order-info-modal"
    >
      <div slot="icon" class="modal-icon">
        <svg width="26" height="24" xmlns="http://www.w3.org/2000/svg">
          <g fill="#FFF" fill-rule="nonzero">
            <path
              d="M22.1 7.8v13H3.9v-13h18.2m2.6-2.6H1.3v18.2h23.4V5.2zM24.7 5.2l-1.881-3.763A2.6 2.6 0 0020.493 0H5.507A2.6 2.6 0 003.18 1.437L1.3 5.2h5.2V3.9a1.3 1.3 0 112.6 0v1.3h2.6V3.9a1.3 1.3 0 112.6 0v1.3h2.6V3.9a1.3 1.3 0 112.6 0v1.3h5.2z"
            />
            <path
              d="M6.5 10.4h2.6v3.9H6.5zM11.7 10.4h2.6v3.9h-2.6zM16.9 10.4h2.6v3.9h-2.6zM6.5 18.2h2.6v2.6H6.5zM11.7 18.2h2.6v3.9h-2.6zM16.9 18.2h2.6v2.6h-2.6zM0 5.2h26v2.6H0z"
            />
            <path d="M0 13h26v2.6H0z" />
          </g>
        </svg>
      </div>
      <div class="modal-split">
        <slot></slot>
      </div>
    </Modal>
  </portal>
</template>

<script>
import Modal from "./Modal.vue";

export default {
  components: { Modal },

  props: ["value"],

  watch: {
    shown() {
      if (!this.shown) {
        console.log("CLOSE!");
        this.$emit("close");
      }
    }
  }
};
</script>

<style lang="scss">
.order-info-modal {
  align-items: flex-end !important;

  .modal-body {
    width: 100% !important;
    border-radius: 20px 20px 0 0 !important;

    .modal-scroll {
      height: 75vh;
      background: #fff;
    }
  }

  .modal-content {
    .modal-split {
      width: 100vw;
      max-width: 979px;
      padding-bottom: 20px;

      .modal-right {
        width: 100%;
        padding: 0 !important;
      }
    }
  }
}
</style>
